import { cn } from '@/lib/utils'

type Props = {
  selectedCount: number
  className?: string
}

const EventActivitySelectedCount = ({ selectedCount, className }: Props) => (
  <span
    className={cn(
      className,
      selectedCount >= 6
        ? 'text-success-foreground'
        : selectedCount === 0
        ? 'text-destructive-foreground'
        : 'text-foreground',
    )}
  >
    {selectedCount}
  </span>
)

export default EventActivitySelectedCount
